/**
 * @generated SignedSource<<e0fd998c862b3fe53d64b204e0a6734d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSisenseUserInput = {
  personId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteSisenseUserMutation$variables = {
  input: DeleteSisenseUserInput;
};
export type DeleteSisenseUserMutation$data = {
  readonly deleteSisenseUser: {
    readonly person: {
      readonly id: string;
      readonly sisenseUserId: string | null;
    } | null;
    readonly viewer: {
      readonly id: string;
      readonly sisenseUserId: string | null;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type DeleteSisenseUserMutation = {
  variables: DeleteSisenseUserMutation$variables;
  response: DeleteSisenseUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sisenseUserId",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSisenseUserPayload",
    "kind": "LinkedField",
    "name": "deleteSisenseUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSisenseUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSisenseUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bd26016d2f14646bc4bed1f42298ca7f",
    "id": null,
    "metadata": {},
    "name": "DeleteSisenseUserMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSisenseUserMutation(\n  $input: DeleteSisenseUserInput!\n) {\n  deleteSisenseUser(input: $input) {\n    person {\n      id\n      sisenseUserId\n    }\n    viewer {\n      id\n      sisenseUserId\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e9ea6aacaad67f4a0e8f395efa011db";

export default node;
